import { render, staticRenderFns } from "./Plain.vue?vue&type=template&id=76c18b4c"
import script from "./Plain.vue?vue&type=script&lang=js"
export * from "./Plain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports